import styled from 'styled-components';
import { Modal as ModalComponent } from 'react-bootstrap';

interface IStatus {
  status: string;
}

export const Container = styled.div`
  min-width: calc(100% - 88px);

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  hr {
    background: #e1e1e1;
    opacity: 1;
  }

  a {
    :hover {
      color: unset;
    }
  }

  .container-fluid {
    max-width: 1460px;
  }

  .btn-new {
    border-radius: 4px;
    background: #ff6900;
    border: none;
  }

  .bg-white {
    border-radius: 8px;
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 8px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 4px;
    }
  }

  .bg-balance {
    border-radius: 8px;
    background: linear-gradient(268deg, #ff9e2d 0%, #ff6900 100%);
  }
`;

export const Filter = styled.div`
  h2 {
    color: #000;
    font-family: 'Roboto';
  }
`;

export const TableList = styled.div`
  .btn-icons {
    background: #ff842f;
    border-radius: 20px;
    padding: 6px 8px;
  }
  .min-w {
    min-width: 2410px;
  }
  .table {
    > div:first-child {
      padding: 0px !important;
    }
    div {
      border: none;
    }
  }

  .content {
    ::-webkit-scrollbar {
      background: transparent;
      width: 5px;
      height: 13px;
      border: none;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #002f6c;
      border-radius: 10px;
    }
  }

  .tb-header {
    background-color: #002f6c;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 12px 16px;
  }

  .tb-body {
    padding: 0 0.5rem;
  }

  .tb-header .tb-row button {
    color: #fff;
    font-family: 'Roboto';
    font-size: 16px;
    font-weight: 400;
    justify-content: center;

    svg {
      color: #fff !important;
    }
  }

  /* .tb-header .tb-row button:last-child {
    width: 138px !important;
    min-width: 138px !important;
  }

  .tb-body .tb-row div:last-child {
    min-width: 138px !important;
    width: auto !important;
  } */

  .tb-header .tb-row button {
    width: 200px;
  }

  .tb-header .tb-row {
    button:nth-child(1) {
      width: 140px;
    }
    button:nth-child(2) {
      width: 140px;
    }
    button:nth-child(3) {
      width: 160px;
    }
    button:nth-child(4) {
      width: 200px;
    }
    button:nth-child(5) {
      width: 230px;
    }
    button:nth-child(6) {
      width: 250px;
    }
    button:nth-child(7) {
      width: 140px;
    }

    button:nth-child(9) {
      width: 150px;
    }
    button:nth-child(10) {
      width: 150px;
    }
    button:nth-child(11) {
      width: 160px;
    }
    button:nth-child(12) {
      width: 170px;
    }

    button:nth-child(14) {
      width: 160px;
    }
    button:nth-child(15) {
      width: 150px;
    }
    button:nth-child(16) {
      width: 140px;
    }
  }

  .tb-body .tb-row {
    padding: 0.5rem 0.5rem;
    text-align: center;

    :not(:last-child) {
      border-bottom: 0.5px solid #e1e1e1;
    }

    div:not(:first-child) {
      color: #7e7e7e;
      font-family: 'Roboto';
      font-size: 16px;
      font-weight: 400;
      width: 200px;
      text-wrap: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    div:nth-child(1) {
      width: 140px;
    }
    div:nth-child(2) {
      width: 140px;
    }
    div:nth-child(3) {
      width: 160px;
    }
    div:nth-child(4) {
      width: 200px;
    }
    div:nth-child(5) {
      width: 230px;
    }
    div:nth-child(6) {
      width: 250px;
    }
    div:nth-child(7) {
      width: 140px;
    }

    div:nth-child(9) {
      width: 150px;
    }
    div:nth-child(10) {
      width: 150px;
    }
    div:nth-child(11) {
      width: 160px;
    }
    div:nth-child(12) {
      width: 170px;
    }

    div:nth-child(14) {
      width: 160px;
    }
    div:nth-child(15) {
      width: 150px;
    }
    div:nth-child(16) {
      width: 140px;
    }
  }

  @media screen and (min-width: 992px) {
    .number-id {
      padding: 0px 7px;
    }
  }
`;

export const Status = styled.p<IStatus>`
  background-color: ${(props) => {
    switch (props.status) {
      case 'Pendente':
        return '#dbb100';
      case 'Pago':
        return '#427242';
      default:
        return '#bf2216';
    }
  }};
  padding: 3px;
`;

export const Modal = styled(ModalComponent)`
  backdrop-filter: blur(3px);

  .title {
    color: #000;
    font-size: 26px;
    font-weight: 500;
  }

  h3 {
    font-size: 26px;
    font-weight: 500;
  }

  label {
    span {
      color: #000;
    }
  }

  .t-container {
    border-radius: 8px;
    border: 1px solid #e1e1e1;
  }

  .t-header {
    border-radius: 8px 8px 0px 0px;
    background: #f4f4f4;
  }

  .t-header span:nth-child(1) {
    width: 25%;
    display: flex;
    justify-content: center;
  }

  .t-header span:nth-child(2) {
    width: 25%;
    display: flex;
    justify-content: center;
  }

  .t-header span:nth-child(3) {
    width: 20%;
    display: flex;
    justify-content: center;
  }

  .t-header span:nth-child(4) {
    width: 15%;
    display: flex;
    justify-content: center;
  }

  .t-header span:nth-child(5) {
    width: 15%;
    display: flex;
    justify-content: center;
  }

  .t-body span:nth-child(1) {
    width: 25%;
    text-align: center;
  }

  .t-body span:nth-child(2) {
    width: 25%;
    text-align: center;
  }

  .t-body span:nth-child(3) {
    width: 20%;
    text-align: center;
  }

  .t-body span:nth-child(4) {
    width: 15%;
    text-align: center;
  }

  .t-body span:nth-child(5) {
    width: 15%;
    text-align: center;
  }

  .t-footer {
    border-radius: 0px 0px 8px 8px;
    background: #ffead9;
  }

  .total {
    color: #202020 !important;

    font-weight: 600 !important;
  }

  .check {
    color: #6a6a6a;
    font-size: 14px;
    font-weight: 500;
    span {
      border-radius: 4px;
      border: 1px solid #c7c7c7;
      width: 24px;
      height: 24px;
    }
  }

  .checked {
    background: #ff842f !important;
  }

  .check-list {
    height: 17px !important;
    width: 17px !important;
  }

  .t-body span {
    color: #202020 !important;
    font-weight: 500 !important;
  }

  .t-body div span {
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .input {
    border: 1px solid rgba(221, 221, 221, 0.87);

    height: 40px;
    border-radius: 4px;

    input {
      color: #202020;
    }
  }

  span:not(.h6) {
    color: #878787;
    font-family: 'Poppins';
    font-size: 12px;
    font-weight: 400;
  }

  p:not(.h6) {
    color: #878787;
    font-family: 'Poppins';
    font-size: 12px;
    font-weight: 400;
    span {
      font-weight: 500;
    }
  }

  .name {
    color: #292623 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    span {
      color: #8c8c8c !important;
      font-weight: 400 !important;
    }
  }

  .arquives {
    border-radius: 8px;
    border: 1px solid #e1e1e1;
  }

  .arquives img {
    width: 48px;
    height: 48px;
    border-radius: 4px;
    border: 1px solid #002f6c;
    object-fit: contain;
  }

  .label-modal {
    padding: 34px 30px;
    border-radius: 20px;
    border: 1px dashed #ff6900;
  }

  .label-modal {
    span:nth-child(2) {
      font-family: 'Roboto';
      color: #8c8c8c;
      font-size: 16px;
      font-weight: 400;
    }

    span:nth-child(3) {
      border-radius: 4px;
      border: 1px solid #ff6900;
      color: #ff6900;
      font-size: 16px;
      font-weight: 400;
      padding: 8px 16px;
    }

    span:nth-child(4) {
      color: #8c8c8c;
      font-family: 'Roboto';
      font-size: 12px;
      font-weight: 400;
    }
  }

  .variations {
    .variation-row {
      > div:first-child {
        width: 50px;

        .size {
          width: 32px;
          height: 32px;
          font-size: 16px;
          font-weight: 400;
          border-radius: 4px !important;
          border: 1px solid #ff842f !important;
          color: #ff842f !important;
          background-color: #fff;
          margin: 0 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      > div:last-child {
        width: calc(100% - 50px);
      }

      + .variation-row {
        margin-top: 10px;
      }
    }
  }

  .height {
    height: 30px;
  }

  .btn-filter {
    border-radius: 4px;
    background-color: #ff6900;
    color: #fff;
  }

  .modal-content {
    border-radius: 8px;
    border: none;
  }

  .add-new-color {
    color: #d4d4d4;
    font-size: 16px;
    font-weight: 400;
    border-radius: 4px;
    border: 1px solid #e2e2e2;
  }
`;
